// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loading_wrapper__21tck","spinner":"loading_spinner__R6KtV","loading":"loading_loading__3VrJg"};